<template>
  <div class="app-score">
    <p class="app-score__heading">{{ $translate('score') }}</p>
    <p class="app-score__current-points" v-html="$store.state.score"/>
  </div>
</template>

<script>
export default {
  name: 'CurrentScore',
};
</script>

<style lang="scss" scoped>
.app-score {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column nowrap;

  font-weight: 800;

  &__heading {
    @extend %font-medium;
    text-transform: uppercase;
    margin-bottom: 8px;

    @include mq(mobileL) {
      margin-bottom: 12px;
    }
  }

  &__current-points {
    @extend %font-big;
  }
}
</style>
